var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"fill-height",attrs:{"align":"center","justify":"center"}},[_c('v-card',{staticClass:"text-center pa-4",attrs:{"flat":""}},[_c('v-progress-circular',{attrs:{"size":"100","indeterminate":"","color":"primary"}}),_c('br'),_c('span',{staticClass:"display-1"},[_vm._v(" "+_vm._s(_vm.loadingText)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }